export function ModuleBlock({ 
    id,
    module, 
    isDragging, 
    isLocked, 
    showConnector, 
    isSelected,
    isComplete,
    onClick,
    sessionStyle,
    SESSION_STYLES
  }) {
    const getBlockStyles = () => {
      if (sessionStyle) {
        return SESSION_STYLES[sessionStyle];
      }
      if (isSelected) {
        return {
          border: 'border-gray-200',
          bg: 'bg-white'
        };
      }
      return {
        border: isLocked && !isComplete ? 'border-gray-200' : 'border-gray-200 hover:border-violet-300',
        bg: isLocked && !isComplete ? 'bg-gray-50' : 'bg-white'
      };
    };
  
    const styles = getBlockStyles();
  
    return (
      <div id={id} className="flex-shrink-0 relative z-10">
        <div className="relative flex flex-col items-center">
          <div
            onClick={onClick}
            className={`
              w-48 h-28 p-4 border-2 rounded-2xl shadow-sm
              transition-all duration-200
              flex items-center justify-center
              ${styles.border}
              ${styles.bg}
              ${isDragging ? 'scale-105 shadow-lg' : ''}
              ${isLocked && !isComplete ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'}
            `}
          >
            <h4 className="text-sm font-medium text-gray-900 text-center">
              {module.title}
            </h4>
          </div>
  
          {isLocked && !isComplete && (
            <div className="absolute -bottom-6 left-1/2 transform -translate-x-1/2">
              <span className="inline-flex items-center px-2 py-1 text-xs font-medium italic text-gray-500">
                Order locked
              </span>
            </div>
          )}
  
          {showConnector && (
            <div className="absolute right-[-1rem] top-1/2 transform -translate-y-1/2">
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                <path 
                  d="M1 8h14M9 3l6 5-6 5" 
                  stroke="currentColor" 
                  strokeWidth="2" 
                  strokeLinecap="round" 
                  strokeLinejoin="round"
                />
              </svg>
            </div>
          )}
        </div>
      </div>
    );
  }